export default 'clientConfig'